const video = () => {
  const videoBtn = document.getElementById('js-btn-video')
  const videoModal = document.getElementById('js-video-modal')
  const closeVideoBtn = document.getElementById('js-close-video-modal-btn')
  html = document.getElementsByTagName('html')[0]

  if (!videoBtn || !videoModal || !closeVideoBtn) return

  const video = document.querySelector('#js-modal-vimeo')
  const iframePlayer = new Vimeo.Player(video)

  iframePlayer.ready().then(function () {
    videoBtn.addEventListener('click', (e) => {
      videoModal.classList.add('js-active')

      iframePlayer.play()
      iframePlayer.setVolume(1)

      html.classList.toggle('js-noscroll')
      html.classList.toggle('js-noscroll-mobile')
    })

    closeVideoBtn.addEventListener('click', (e) => {
      iframePlayer.pause()

      videoModal.classList.remove('js-active')

      html.classList.toggle('js-noscroll')
      html.classList.toggle('js-noscroll-mobile')
    })
  })
}

export default video
